import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { OrganizationCloseStageRow } from "../organizationCloseStagesViewConfig";
import styles from "../OrganizationCloseStages.module.scss";

export const OrganizationCloseStageNameCell = memo(
    ({
        row,
    }: CellContext<ViewTableFeatures, OrganizationCloseStageRow, string>) => (
        <span className={styles.name}>{row.original.name}</span>
    ),
);
